// eslint-disable-next-line import/prefer-default-export
export const SITE_SEO_META = {
  AVAILABILITY: {
    title: 'Visage availability',
    description: 'The page provides the availability of Visage across all the live sites.',
  },
  CHANGELOG: {
    title: 'Visage changelog',
    description: 'View the feature and bug fix releases.',
  },
  COMPONENTS: {
    title: 'Components',
    description: 'List of all the available Visage components for building your site.',
  },
  DEVELOP: {
    title: 'Dev setup',
    description: 'Installing, using, and contributing to Visage code.',
  },
  ROOT: {
    title: 'Visage Design System',
    description: 'As of Jan 1, 2023, Visage is now deprecated, and is no longer supported. Please see its successor, SWAN.',
  },
  PREVIEW: {
    title: 'Preview code',
    description: 'Live playground for Visage.',
  },
}
